import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { State } from '../../../store/reducers';
import { Store } from '@ngrx/store';

import * as bookingActions from '../../../store/actions/booking.action';
import { Router } from '@angular/router';
import { Booking } from '../../models/booking';
import { Subscription } from 'rxjs/Subscription';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-conferenceinfo',
  templateUrl: './conferenceinfo.component.html',
  styleUrls: ['./conferenceinfo.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConferenceinfoComponent implements OnInit, OnDestroy {
  conferenceinfoForm: FormGroup;
  ngynSubscription: Subscription;
  includeInBusinessDecision = ['Yes', 'No'];
  groupAList = [
    'Advocacy & Prophetic Voice to the Nations',
    "Children's Ministry",
    'Christian Business Ethics and Network',
    'Evangelism',
    'Reaching people with disabilities',
    "Women's Ministry"
  ];

  groupBList = [
    'Deliverance & prophetic ministry challenges',
    'Discipleship',
    'Humanitarian Aid & Disaster Relief',
    'Prayer',
    'Theological Scholars',
    'Younger Generation'
  ];

  public value = [];
  constructor(
    private fb: FormBuilder,
    private store: Store<State>,
    private router: Router
  ) {}

  ngOnInit() {
    this.createForm();
    // this.store
    //   .select(state => state.booking.)
    //   .subscribe(booking => this.createForm(booking));

    this.ngynSubscription = this.conferenceinfoForm
      .get('includeNgyn')
      .valueChanges.pipe(
        map(value => {
          if (value) {
            this.store.dispatch(new bookingActions.IncludeNgynConference());
          } else {
            this.store.dispatch(new bookingActions.ExcludeNgynConference());
          }
        })
      )
      .subscribe();
  }

  createForm() {
    this.conferenceinfoForm = this.fb.group({
      nameOfChurch: '',
      groupASession: ['', Validators.required],
      groupBSession: ['', Validators.required],
      includeNgyn: false,
      includeInBusiness: false,
      expertise: ''
    });
  }

  submitConferenceInfo() {
    this.store.dispatch(
      new bookingActions.AddConferenceInfo(this.conferenceinfoForm.value)
    );
    this.router.navigate(['/bookings/add/accommodation-info']);
  }

  cancel() {
    this.router.navigate(['/bookings']);
  }

  jumpToTour() {
    this.router.navigate(['/bookings/add/tour-info']);
  }

  ngOnDestroy() {
    if (this.ngynSubscription) {
      this.ngynSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/conferenceinfo/conferenceinfo.component.ts